import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=6daa6dea&"
import script from "./BigScreen.vue?vue&type=script&lang=js&"
export * from "./BigScreen.vue?vue&type=script&lang=js&"
import style0 from "./BigScreen.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports